import React from "react"
import "./FormField.css"

import DatePicker from "react-datepicker"

// component for form fields
// any props (other than label, icon, className and children) will be applied to the input element. this way you can specify the input type, event listeners, etc
// label prop will be used for the label html element
// icon prop (if there is one) should be the name of the icon without the mdi- prefix
// className prop will be added to the form-field container div

function FormDatePicker(props) {
  const {
    id,
    minDate,
    maxDate,
    className,
    label,
    header,
    icon,
    maxWidth,
    noMargin,
    noShadow,
    ...datePickerProps
  } = props
  return (
    <div
      className={
        "form-field" +
        (className ? " " + className : "") +
        (maxWidth ? " form-date-picker-max-width" : "") +
        (noMargin ? " mb-1" : " mb-3")
      }
    >
      {label ? <label htmlFor={id}>{label}</label> : null}
      {header}
      <div className="form-input">
        {icon ? <i className={"form-icon mdi mdi-" + icon}></i> : ""}
        <DatePicker
          id={id}
          className={noShadow ? "form-control no-shadow" : 'form-control'}
          minDate={minDate}
          maxDate={maxDate}
          popperModifiers={{
            preventOverflow: {
              enabled: true
            }
          }}
          {...datePickerProps}
        />
      </div>
    </div>
  )
}

export default FormDatePicker
